/*eslint-disable*/
import { useEffect, useState } from 'react';
import type { FC } from 'react';
import {
  Link as RouterLink,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Button, Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
// import ReceiptIcon from '@material-ui/icons/Receipt';
import useAuth from '../../hooks/useAuth';
import ChartPieIcon from '../../icons/ChartPie';
import Glossary from '../../icons/Glossary';
import Help from '../../icons/Help';
import ChartSquareBarIcon from '../../icons/ChartSquareBar';
import UsersIcon from '../../icons/Users';
import ContractIcon from '../../icons/Contract';
import UserIcon from '../../icons/User';
import ProviderIcon from '../../icons/Provider';
import ConfigIcon from '../../icons/Adjustments';
import LogoP from '../LogoP';
import AssessmentIcon from '@material-ui/icons/Assessment';
// import UsersIcon from '../../icons/Users';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import BusinessIcon from '@material-ui/icons/Business';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';

// Be sure to include styles at some point, probably during your bootstraping
import './sidebar.css';

interface DashboardSidebarProps {
  onMobileClose: () => void;
  openMobile: boolean;
}

const subtitles = {
  subProvider: 'Proveedor',
  subMaster: 'Prior',
  subAdmin: 'Prior',
  subStandar: 'Prior',
};
const DashboardSidebar: FC<DashboardSidebarProps> = (props) => {
  const { onMobileClose, openMobile } = props;
  const location = useLocation();
  const { user } = useAuth();
  const { t } = useTranslation('sidebar');
  const [menuExpanded, setMenuExpanded] = useState(false);
  const navigate = useNavigate();
  let urlSplit = location.pathname.split('/');
  const [selectedMenu, setSelectedMenu] = useState(
    urlSplit ? urlSplit[urlSplit.length - 1] : 'dashboard'
  );

  const sectionMaster = [
    {
      to: 'settings',
      icon: (
        <ConfigIcon
          fontSize="small"
          sx={{
            color: selectedMenu === 'settings' ? '#ffad02' : '#af9fa4',
          }}
        />
      ),
      title: 'Configuración',
    },
    {
      to: 'contract',
      icon: (
        <ContractIcon
          fontSize="small"
          sx={{
            color: selectedMenu === 'contract' ? '#ffad02' : '#af9fa4',
          }}
        />
      ),
      title: 'Contratos',
    },
    // {
    //   to: 'users',
    //   icon: (
    //     <UsersIcon
    //       fontSize="small"
    //       sx={{
    //         color: selectedMenu === 'users' ? '#ffad02' : '#af9fa4',
    //       }}
    //     />
    //   ),
    //   title: 'Usuarios',
    // },
    // {
    //   to: 'providers',
    //   icon: (
    //     <ProviderIcon
    //       fontSize="small"
    //       sx={{
    //         color: selectedMenu === 'providers' ? '#ffad02' : '#af9fa4',
    //       }}
    //     />
    //   ),
    //   title: 'Proveedores',
    // },
    // {
    //   to: 'transactions',
    //   icon: (
    //     <AssessmentIcon
    //       fontSize="small"
    //       sx={{
    //         color: selectedMenu === 'transactions' ? '#ffad02' : '#af9fa4',
    //       }}
    //     />
    //   ),
    //   title: 'Transacciones',
    // },
    // {
    //   to: 'analytics',
    //   icon: (
    //     <ChartPieIcon
    //       fontSize="small"
    //       sx={{
    //         color: selectedMenu === 'analytics' ? '#ffad02' : '#af9fa4',
    //       }}
    //     />
    //   ),
    //   title: 'Analítica',
    // },
   
    {
      to: 'glossary',
      icon: (
        <Glossary
          fontSize="small"
          sx={{
            color: selectedMenu === 'glossary' ? '#ffad02' : '#af9fa4',
          }}
        />
      ),
      title: 'Glosario',
    },

    {
      to: 'help',
      icon: (
        <Help
          fontSize="small"
          sx={{
            color: selectedMenu === 'help' ? '#ffad02' : '#af9fa4',
          }}
        />
      ),
      title: 'Ayuda',
    },
  ];

  const sectionEstandar = [
    {
      to: 'transactions',
      icon: (
        <AssessmentIcon
          fontSize="small"
          sx={{
            color: selectedMenu === 'transactions' ? '#ffad02' : '#af9fa4',
          }}
        />
      ),
      title: 'Transacciones y Reportería',
    },
    {
      to: 'analytics',
      icon: (
        <ChartPieIcon
          fontSize="small"
          sx={{
            color: selectedMenu === 'analytics' ? '#ffad02' : '#af9fa4',
          }}
        />
      ),
      title: 'FI & Analytics',
    },
  ];

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    let urlSplit = location.pathname.split('/');
    setSelectedMenu(urlSplit[urlSplit.length - 1]);
  }, [location.pathname]);

  return (
    <>
      <SideNav
        onSelect={(eventKey, event) => {
          // setSelectedMenu(eventKey);
        }}
        onToggle={(expanded) => {
          setMenuExpanded(expanded);
        }}
      >
        <SideNav.Toggle
          style={{
            backgroundColor: '#0d2b47',
            width: '100%',
            borderBottom: menuExpanded ? '3px solid #ffae00' : '0px',
          }}
        />
        <SideNav.Nav>
          {!menuExpanded && (
            <NavItem
              style={{
                borderBottom: '3px solid #ffae00',
                backgroundColor: '#0d2b47',
              }}
              eventKey="dashboard"
            >
              <NavIcon>
                <Box></Box>
                <LogoP />
              </NavIcon>
            </NavItem>
          )}
          <NavItem eventKey="dashboard">
            <NavIcon>
              <Tooltip sx={{ zIndex: 99 }} title="Dashboard" placement="right">
                <Button
                  component={RouterLink}
                  startIcon={
                    <ChartSquareBarIcon
                      sx={{
                        color:
                          selectedMenu === 'dashboard' ? '#ffad02' : '#af9fa4',
                      }}
                      fontSize="small"
                    />
                  }
                  to={'/dashboard'}
                />
              </Tooltip>
            </NavIcon>
            <NavText>
              <Button
                component={RouterLink}
                to={'/dashboard'}
                sx={{
                  color:
                    selectedMenu === 'dashboard'
                      ? '#ffad02 !important'
                      : '#af9fa4',
                }}
              >
                Dashboard
              </Button>
            </NavText>
          </NavItem>

          <NavItem eventKey="presupuesto_efectivo">
            <NavIcon>
              <Tooltip sx={{ zIndex: 99 }} title="Presupuesto de Efectivo" placement="right">
                <Button
                    component={RouterLink}
                    startIcon={
                      <MonetizationOnIcon
                          sx={{
                            color:
                                selectedMenu === 'presupuesto_efectivo' ? '#ffad02' : '#af9fa4',
                          }}
                          fontSize="small"
                      />
                    }
                    to={'presupuesto_efectivo'}
                />
              </Tooltip>
            </NavIcon>
            <NavText>
              <Button
                  component={RouterLink}
                  to={'presupuesto_efectivo'}
                  sx={{
                    fontSize: '13px',
                    color:
                        selectedMenu === 'presupuesto_efectivo'
                            ? '#ffad02 !important'
                            : '#af9fa4',
                  }}
              >
                Presupuesto de Efectivo
              </Button>
            </NavText>
          </NavItem>

          <NavItem eventKey="balance_general">
            <NavIcon>
              <Tooltip sx={{ zIndex: 99 }} title="Balance General Proforma" placement="right">
                <Button
                  component={RouterLink}
                  startIcon={
                    <BusinessIcon
                      sx={{
                        color:
                          selectedMenu === 'balance_general' ? '#ffad02' : '#af9fa4',
                      }}
                      fontSize="small"
                    />
                  }
                  to={'balance_general'}
                />
              </Tooltip>
            </NavIcon>
            <NavText>
              <Button
                component={RouterLink}
                to={'balance_general'}
                sx={{
                  color:
                    selectedMenu === 'balance_general'
                      ? '#ffad02 !important'
                      : '#af9fa4',
                }}
              >
                Balance General Proforma
              </Button>
            </NavText>
          </NavItem>

          <NavItem eventKey="estado_resultados">
            <NavIcon>
              <Tooltip sx={{ zIndex: 99 }} title="Estado de Resultados Proforma" placement="right">
                <Button
                  component={RouterLink}
                  startIcon={
                    <AssessmentIcon
                      sx={{
                        color:
                          selectedMenu === 'estado_resultados' ? '#ffad02' : '#af9fa4',
                      }}
                      fontSize="small"
                    />
                  }
                  to={'estado_resultados'}
                />
              </Tooltip>
            </NavIcon>
            <NavText>
              <Button
                component={RouterLink}
                to={'estado_resultados'}
                sx={{
                  fontSize: '13px',
                  color:
                    selectedMenu === 'estado_resultados'
                      ? '#ffad02 !important'
                      : '#af9fa4',
                }}
              >
                Estado de Resultados Proforma
              </Button>
            </NavText>
          </NavItem>

          <NavItem eventKey="estado_Flujo">
            <NavIcon>
              <Tooltip sx={{ zIndex: 99 }} title="Estado de Flujo de Efectivo" placement="right">
                <Button
                  component={RouterLink}
                  startIcon={
                    <LocalAtmIcon
                      sx={{
                        color:
                          selectedMenu === 'estado_Flujo' ? '#ffad02' : '#af9fa4',
                      }}
                      fontSize="small"
                    />
                  }
                  to={'estado_Flujo'}
                />
              </Tooltip>
            </NavIcon>
            <NavText>
              <Button
                component={RouterLink}
                to={'estado_Flujo'}
                sx={{
                  fontSize: '13px',
                  color:
                    selectedMenu === 'estado_Flujo'
                      ? '#ffad02 !important'
                      : '#af9fa4',
                }}
              >
                Estado de Flujo de Efectivo
              </Button>
            </NavText>
          </NavItem>

          <NavItem eventKey="indicadores_financieros">
            <NavIcon>
              <Tooltip sx={{ zIndex: 99 }} title="Indicadores Financieros" placement="right">
                <Button
                  component={RouterLink}
                  startIcon={
                    <TrendingUpIcon
                      sx={{
                        color:
                          selectedMenu === 'indicadores_financieros' ? '#ffad02' : '#af9fa4',
                      }}
                      fontSize="small"
                    />
                  }
                  to={'indicadores_financieros'}
                />
              </Tooltip>
            </NavIcon>
            <NavText>
              <Button
                component={RouterLink}
                to={'indicadores_financieros'}
                sx={{
                  fontSize: '13px',
                  color:
                    selectedMenu === 'indicadores_financieros'
                      ? '#ffad02 !important'
                      : '#af9fa4',
                }}
              >
                Indicadores Financieros
              </Button>
            </NavText>
          </NavItem>

          {/*<NavItem eventKey="detalle_indicadores_financieros">*/}
          {/*  <NavIcon>*/}
          {/*    <Tooltip sx={{ zIndex: 99 }} title="Detalle Indicadores Financieros" placement="right">*/}
          {/*      <Button*/}
          {/*        component={RouterLink}*/}
          {/*        startIcon={*/}
          {/*          <TrendingUpIcon*/}
          {/*            sx={{*/}
          {/*              color:*/}
          {/*                selectedMenu === 'detalle_indicadores_financieros' ? '#ffad02' : '#af9fa4',*/}
          {/*            }}*/}
          {/*            fontSize="small"*/}
          {/*          />*/}
          {/*        }*/}
          {/*        to={'detalle_indicadores_financieros'}*/}
          {/*      />*/}
          {/*    </Tooltip>*/}
          {/*  </NavIcon>*/}
          {/*  <NavText>*/}
          {/*    <Button*/}
          {/*      component={RouterLink}*/}
          {/*      to={'detalle_indicadores_financieros'}*/}
          {/*      sx={{*/}
          {/*        fontSize: '13px',*/}
          {/*        color:*/}
          {/*          selectedMenu === 'detalle_indicadores_financieros'*/}
          {/*            ? '#ffad02 !important'*/}
          {/*            : '#af9fa4',*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      Detalle Indicadores Financieros*/}
          {/*    </Button>*/}
          {/*  </NavText>*/}
          {/*</NavItem>*/}
          {/*<NavItem eventKey="account">*/}
          {/*  <NavIcon>*/}
          {/*    <Tooltip sx={{ zIndex: 99 }} title="Mi Perfil" placement="right">*/}
          {/*      <Button*/}
          {/*        component={RouterLink}*/}
          {/*        startIcon={*/}
          {/*          <UserIcon*/}
          {/*            fontSize="small"*/}
          {/*            sx={{*/}
          {/*              color:*/}
          {/*                selectedMenu === 'account' ? '#ffad02' : '#af9fa4',*/}
          {/*            }}*/}
          {/*          />*/}
          {/*        }*/}
          {/*        to={'account'}*/}
          {/*      />*/}
          {/*    </Tooltip>*/}
          {/*  </NavIcon>*/}
          {/*  <NavText>*/}
          {/*    <Button*/}
          {/*      component={RouterLink}*/}
          {/*      to={'account'}*/}
          {/*      sx={{*/}
          {/*        color:*/}
          {/*          selectedMenu === 'account'*/}
          {/*            ? '#ffad02 !important'*/}
          {/*            : '#af9fa4',*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      Mi Perfil*/}
          {/*    </Button>*/}
          {/*  </NavText>*/}
          {/*</NavItem>*/}
          {user.isAdminUser === true && (
            <NavItem eventKey="business">
              <NavIcon>
                <Tooltip sx={{ zIndex: 99 }} title="Empresas" placement="right">
                  <Button
                    component={RouterLink}
                    startIcon={
                      <UserIcon
                        fontSize="small"
                        sx={{
                          color:
                            selectedMenu === 'business' ? '#ffad02' : '#af9fa4',
                        }}
                      />
                    }
                    to={'business'}
                  />
                </Tooltip>
              </NavIcon>
              <NavText>
                <Button
                  component={RouterLink}
                  to={'business'}
                  sx={{
                    color:
                      selectedMenu === 'business'
                        ? '#ffad02 !important'
                        : '#af9fa4',
                  }}
                >
                  Empresas
                </Button>
              </NavText>
            </NavItem>
          )}
          {user.isAdminUser === false &&
            user.rol === 'master' &&
            sectionMaster.map((item, index) => (
              <NavItem key={`menusidebar-master${index}`} eventKey={item.to}>
                <NavIcon>
                  <Tooltip
                    sx={{ zIndex: 99 }}
                    title={item.title}
                    placement="right"
                  >
                    <Button
                      component={RouterLink}
                      startIcon={item.icon}
                      to={item.to}
                    />
                  </Tooltip>
                </NavIcon>
                <NavText>
                  <Button
                    component={RouterLink}
                    to={item.to}
                    sx={{
                      color:
                        selectedMenu === item.to
                          ? '#ffad02 !important'
                          : '#af9fa4',
                    }}
                  >
                    {item.title}
                  </Button>
                </NavText>
              </NavItem>
            ))}
          {user.isAdminUser === false &&
            user.rol === 'estandar' &&
            sectionEstandar.map((item, index) => (
              <NavItem key={`menusidebar-estandar${index}`} eventKey={item.to}>
                <NavIcon>
                  <Tooltip
                    sx={{ zIndex: 99 }}
                    title={item.title}
                    placement="right"
                  >
                    <Button
                      component={RouterLink}
                      startIcon={item.icon}
                      to={item.to}
                    />
                  </Tooltip>
                </NavIcon>
                <NavText>
                  <Button
                    component={RouterLink}
                    to={item.to}
                    sx={{
                      color:
                        selectedMenu === item.to
                          ? '#ffad02 !important'
                          : '#af9fa4',
                    }}
                  >
                    {item.title}
                  </Button>
                </NavText>
              </NavItem>
            ))}
          {/*<NavItem eventKey="help">*/}
          {/*  <NavIcon>*/}
          {/*    <Button*/}
          {/*      component={RouterLink}*/}
          {/*      // startIcon={<ChartPieIcon fontSize="small" />}*/}
          {/*      to={'help'}*/}
          {/*    />*/}
          {/*  </NavIcon>*/}
          {/*  <NavText>*/}
          {/*    <Button*/}
          {/*      component={RouterLink}*/}
          {/*      to={'help'}*/}
          {/*      sx={{*/}
          {/*        color:*/}
          {/*          selectedMenu === 'help' ? '#ffad02 !important' : '#af9fa4',*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      ¿Necesitas ayuda?*/}
          {/*    </Button>*/}
          {/*  </NavText>*/}
          {/*</NavItem>*/}
        </SideNav.Nav>
      </SideNav>
    </>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default DashboardSidebar;
